export const listenerConstants = {
    EXPORT_ORDER_SUCCESS: 'EXPORT_ORDER_SUCCESS',
    EXPORT_ORDER_FAILURE: 'EXPORT_ORDER_FAILURE',
    EXPORT_ORDER_REQUEST: 'EXPORT_ORDER_REQUEST',

    EXPORT_FACTURE_SUCCESS: 'EXPORT_FACTURE_SUCCESS',
    EXPORT_FACTURE_FAILURE: 'EXPORT_FACTURE_FAILURE',
    EXPORT_FACTURE_REQUEST: 'EXPORT_FACTURE_REQUEST',
};